import { api } from '@/api'

export default {
  // ローカルデータをクリーンアップする。Appだけでなく他モジュールのクリーンアップもコールする。
  clearData ({ commit, dispatch }) {
    commit('setGroup', {})
    commit('setMaxLevel', 0)
    commit('setExpandedIds', [])
    // dispatch('clearTimer')
  },

  // 「データ取得時間」を現在時刻にセットし、１分ごとに「現在時刻」をアップデートするインターバルを開始する。
  startTimer ({ state, commit, dispatch }) {
    // 既にタイマーが存在していればクリアする。
    if (state.intervalId) {
      dispatch('clearTimer')
    }
    commit('setCurrentTimestamp', new Date().getTime())
    commit('setFetchedTimestamp', new Date().getTime())
    commit('setIntervalId', setInterval(() => {
      commit('setCurrentTimestamp', new Date().getTime())
    }, 1000 * 60))
  },
  // タイマーをクリアする。
  clearTimer ({ state, commit }) {
    clearInterval(state.intervalId)
    commit('setIntervalId', null)
    commit('setCurrentTimestamp', null)
    commit('setFetchedTimestamp', null)
  },

  async initGroupData ({ rootState, commit }, init = false) {
    let { groups } = await api.searchGroups({ _with: 'group' })

    if (rootState.app.user.roleId === 1) {
      groups = [findDeliveryArea(groups, rootState.app.deliveryGroupId)]
    }

    const parentId = rootState.app.company.id === 1 ? -1 : 1
    const group = arrangeData(groups, parentId)[0]
    commit('setGroup', group)
    commit('setMaxLevel', maxLevel)

    if (init) commit('setExpandedIds', [group.id])

    // dispatch('startTimer')

    return group
  },
  /**
   * グループを作成・更新する
   * @param {*} _ vuexPayload
   * @param {{any}} value グループオブジェクト
   * @return {{id: Number, message: String}} 対象グループのIDと結果
   */
  async updateGroup (_, value) {
    let message, id

    if (value.type === 'area') {
      const data = {
        groupName: value.name,
        groupType: 'area',
        parentGroupId: value.parentGroupId,
        remarks: value.remarks
      }

      if (value.id === 'new') {
        // 新規エリア
        const res = await api.createGroup(data)
        id = res.id
        message = `${value.name}を作成しました。`
      } else {
        // エリア更新
        await api.updateGroup(data, value.id)
        message = `${value.name}のデータを更新しました。`
      }
    } else if (value.type === 'company') {
      const data = {
        companyName: value.name,
        parentGroupId: value.parentGroupId,
        address: value.address,
        tel: value.tel,
        remarks: value.remarks,
        representativeName: value.representativeName,
        representativePassword: value.representativePassword
      }
      if (value.id === 'new') {
        // 新規会社
        const res = await api.createCompany(data)
        id = res.id
        message = `${value.name}を作成しました。`
      } else {
        // 会社更新
        await api.updateCompany(data, value.id)
        message = `${value.name}のデータを更新しました。`
      }
    } else {
      throw new Error('「エリア」か「会社」どちらかのタイプを指定してください。')
    }

    return { id, message }
  }
}

let maxLevel = 0

/**
     * グループのリストをフラットな構造に変換します。
     */
const arrangeData = (groups, parentId, level = 0) => {
  maxLevel = Math.max(maxLevel, level - 1)

  return groups.map(g => {
    const types = typesMap.get(g.type)
    return {
      id: g.id,
      level,
      type: g.type || '',
      typeName: types.text || '',
      icon: types.icon,
      name: g.name || '',
      tel: g.tel || '',
      address: g.address || '',
      representativeName: g.representative?.name || '',
      remarks: g.remarks || '',
      sensorsRest: null,
      parentGroupId: parentId,
      children: arrangeData(g.children, g.id, level + 1)
    }
  })
}

const typesMap = new Map([
  ['main_company', { text: '管理会社', icon: 'mdi-domain' }],
  ['company', { text: '会社', icon: 'mdi-office-building' }],
  ['area', { text: 'エリア', icon: 'mdi-home' }]
])

const findDeliveryArea = (group, deliveryGroupId) => {
  let area
  const find = (children) => {
    for (let child of children) {
      if (child.id === deliveryGroupId) {
        area = child
        return
      } else {
        if (child.children.length) {
          find(child.children, deliveryGroupId)
        }
      }
    }
  }
  find(group[0].children)
  return area
}
